import { faArrowLeft, faBriefcaseMedical, faChevronRight, faFileInvoice, faListCheck, faPlus, faPowerOff, faUser, faUserGroup, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthController from "../../apis/Controllers/AuthController/AuthController";
import { Drawer_profile, LeftIcon, Menu, NotificationBell, Search } from "../../assets/images";
import { setUserData } from "../../redux/actions/users";
import store from "../../redux/store";


const WithoutImageHeader = (props) => {

    const [drawerState, setDrawerState] = useState()
    const navigate = useNavigate();

    useEffect(() => {
        var x = window.matchMedia("(max-width: 700px)")
        setDrawerState(x)
        getUserData();
    }, []);


    const getUserData = async () => {
        window.scrollTo(0, 0);
        let item = localStorage.getItem('SET_USER_DATA');
        item = JSON.parse(item);
        let user = item;
        if (user) {
            if (user && user.access && user.access.token) {
                await store.dispatch(setUserData(user));
            }
        }
        else {
            logout();
        }
    };


    const logout = async () => {
        store.dispatch(setUserData({}));
        localStorage.clear();
        navigate("/login");
    };

    const openNav = () => {
        document.getElementById("mySidenav").style.width = drawerState.matches ? "100%" : "450px";
    };

    const closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    };

    const drawerList = [
        {
            name: 'Dashboard',
            path: '/dashboard-superadmin',
            icon: faBriefcaseMedical,
            active: false
        },
        {
            name: 'Manage Hospitals',
            path: '/hospital-listing',
            icon: faBriefcaseMedical,
            active: false
        },
        {
            name: 'Manage Staf',
            path: '/dashboard-superadmin',
            icon: faUserGroup,
            active: false
        },
        {
            name: 'Manage Patient',
            path: '/dashboard-superadmin',
            icon: faUser,
            active: false
        },
        {
            name: 'Manage Tasks',
            path: '/dashboard-superadmin',
            icon: faListCheck,
            active: false
        },
        {
            name: 'Manage Roles',
            path: '/role-list',
            icon: faFileInvoice,
            active: false
        },
    ]


    return (
        <>
            <div id="mySidenav" className="sidenav">
                <div className="header_area">
                    <div className="icon_top" onClick={closeNav} >
                        <a href="javascript:;">  <Image src={LeftIcon} alt="..." /></a>
                    </div>
                    <div className="profile_info">
                        <div className="img_area">
                            <Image src={Drawer_profile} alt="..." />
                        </div>
                        <h5>William Victoria</h5>
                        <p>Super Admin</p>
                    </div>
                </div>
                <div className="body_area">
                    <div className="content_area">
                        <div className="left_area">
                            <p>Oxford Hospital</p>
                        </div>
                        <div className="right_area">
                            <a href="javascript:;" className="btn btn-primary">Change</a>
                        </div>
                    </div>
                    <div className="list_area">
                        <ul>
                            {drawerList.map((item, index) => (
                                <li key={index} className={item.active ? "active" : ""}><a href={item.path}>
                                    <div className="text_icon_area">
                                        <div className="left_icon">
                                            <div className="icon_box">
                                                <FontAwesomeIcon icon={item.icon} />
                                            </div>
                                        </div>
                                        <div className="right_text">
                                            <p>{item.name}</p>
                                        </div>
                                    </div>
                                </a></li>
                            ))}
                            <li><a href="javascript:;" onClick={() => AuthController.logout()}>
                                <div className="text_icon_area">
                                    <div className="left_icon">
                                        <div className="icon_box">
                                            <FontAwesomeIcon icon={faPowerOff} />
                                        </div>
                                    </div>
                                    <div className="right_text">
                                        <p onClick={() => AuthController.logout()}>Log Out</p>
                                    </div>
                                </div>
                            </a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="without_image_header">
                <div className="header_area">
                    <div className="details">
                        {props.lefticon === 'menu' ?
                            <div className="menu_icon">
                                <div className="img_menu">
                                    <Image src={Menu} alt="..." onClick={openNav} />
                                </div>
                            </div>
                            :
                            <FontAwesomeIcon icon={faArrowLeft} className="arrow" onClick={() => props && props.handleBack ? props.handleBack() : ''} />}
                        <h3>{props.header}</h3>
                        {props.icon === "edit" ?
                            <div className="icon_user" onClick={() => props && props.handleNavigate ? props.handleNavigate() : ''}>
                                <FontAwesomeIcon icon={faUserPen} />
                            </div>
                            :
                            props.icon === "notification" ?
                                <div className="search_area">
                                    <div className="img_search">
                                        <Image src={NotificationBell} alt="..." />
                                    </div>
                                </div>
                                :
                                props.icon === "add" ?
                                    <div className="add_area">
                                        <a href="javascript:;"><FontAwesomeIcon icon={faPlus} className="add_icon" />Add</a>
                                    </div>
                                    : props.icon === "search_bell" ?
                                        <div className="icon_area">
                                            <div className="img_one">
                                                <Image src={Search} alt="..." />
                                            </div>
                                            <div className="img_two">
                                                <Image src={NotificationBell} alt="..." />
                                            </div>
                                        </div> : null}
                    </div>
                    <div className="breadcrum_area">

                        {props.breadcrumData ? props.breadcrumData.map((item, i) =>
                            <div>
                                <a href="#javscript:;" >{item}</a><FontAwesomeIcon icon={faChevronRight} className="icon" />
                            </div>
                        ) : null}

                        <span>{props.breadcrumItem}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WithoutImageHeader;